import { render, staticRenderFns } from "./veStuHygieneItemShow.vue?vue&type=template&id=138e4ad0&scoped=true"
import script from "./veStuHygieneItemShow.vue?vue&type=script&lang=js"
export * from "./veStuHygieneItemShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e4ad0",
  null
  
)

export default component.exports